export default {
  fillInOrder: '填写代购订单',
  inputTips: "（<span style='color: red'>*</span>为必填项）",
  process: {
    first: '填写订单并提交',
    second: '支付商品费用和国内运费',
    three: '等待商品到达仓库',
  },
  productInfo: '商品信息',
  productInfoTips:
    'acbuy上显示的所有可代购商品均来自第三方购物平台，并非由acbuy直接销售。因此，如果上述商品涉及任何侵权问题，所有产生的责任均由第三方平台上的相应卖家承担，acbuy不承担任何相关、附带或连带责任。',
  fees: '费用',
  feeStandard: '费用标准',
  feeStandardTips:
    '对于您在本页面提交的代购订单，如果商品来自孔夫子二手书、小红书、有赞等第三方平台，可能存在无法购买的情况。商品可能存在运输风险，或可能收取额外的服务费。实际服务费需要由代理商核实。更多详情，请查看"帮助中心 - 第三方代购服务费用标准"。',
  link: '链接',
  name: '名称',
  remark: '备注',
  unitPrice: '单价（人民币）',
  qty: '数量',
  goodsAttr: '规格或材质',
  chinaPostage: '运费（人民币）',
  holder: {
    inputUrl: '请粘贴商品URL',
    inputName: '请在此输入商品名称（100字以内）',
    inputAttr: '请输入商品规格',
    inputRemark:
      '如果商品有多种款式、尺寸、颜色等，请根据商品页面的分类描述在此指定您需要的。如果您购买相同商品但规格不同，请分开下单。',
    contactName: '请输入联系方式',
    contactEmail: '请输入联系邮箱',
    contactPhone: '请输入联系电话',
  },
  other: '其他（可选）',
  productImg: '商品图片',
  fareTip: '寄送到仓库地址的国内运费（如果不确定可以填写0，采购会帮你核实，并发起补款）',
  customizedLogisticsForm: '定制物流申请表',
  submitInfo: '提交产品信息',
  customizedProcess: {
    first: '填写订单并提交',
    second: '提交产品信息',
    three: '等待acbuy联系您',
  },
  deliveryAddress: '邮寄地址',
  contactDetail: '联系详情',
  contactName: '联系名称',
  contactPhone: '联系电话',
  contactEmail: '联系邮箱',
  customizedLogisticsInformation: '定制物流信息',
  fromWarehouse: '从仓库',
  manuallyFill: '手动填写商品信息',
  contactInfoTips1:
    '·为了更好地为您服务，请如实详细填写表格。在提交申请后的三个工作日内，专门的工作人员将与您联系。 ',
  contactInfoTips2: '·对于30KG以下的包裹，建议客户选择在线物流配送。',
  contactInfoTips3: '·定制服务只涉及物流运输，货物只进行外观检查，不提供货物的详细质量检查。',
  myWarehouse: '我的仓库',
  itemName: '商品名称',
  volume1: '商品打包后的体积信息',
  volume: '体积(cm)',
  weight: '重量',
  length: '长',
  width: '宽',
  height: '高',
  warehouseItem: '仓库商品',
  manuallyItem: '手动商品',
  submitSuccess: '定制物流申请提交成功',
  submitMsg: '我们会尽快与您联系，请耐心等待。',
  inputProductMsg: '请输入商品信息',
  selectZone: '请选择联系电话区号',
  productName: '商品链接或名称',
}
